import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// This component is used to force a re-render of element(s) when it mounts,
// which will only occur on the client side. This allows us to fix difficult
// SSR issues, but comes with a performance cost so should be used sparingly.

const ReRenderOnMount = t0 => {
  const $ = _c(6);
  const {
    children,
    shouldReRender: t1
  } = t0;
  const shouldReRender = t1 === undefined ? true : t1;
  const [renderKey, setRenderKey] = useState("unmounted");
  let t2;
  let t3;
  if ($[0] !== shouldReRender) {
    t2 = () => {
      if (shouldReRender) {
        setRenderKey("mounted");
      }
    };
    t3 = [shouldReRender];
    $[0] = shouldReRender;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== children || $[4] !== renderKey) {
    t4 = <Fragment key={renderKey}>{children}</Fragment>;
    $[3] = children;
    $[4] = renderKey;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
ReRenderOnMount.propTypes = {
  children: PropTypes.node,
  shouldReRender: PropTypes.bool
};
export default ReRenderOnMount;